import { routes } from '@/assets/constants/routes-no.ts';
import { Testimonials } from '@/components/testimonials/index.ts';
import type { TestimonialsData } from '@/lib/api/requests.ts';
import { SEO } from '@/lib/seo.tsx';

import ActionButton from '../../../components/ActionButton/index.ts';
import Circle from '../../../components/Circle/index.ts';
import FaqList from '../../../components/FaqList/index.ts';
import PartnerBanks from '../../../components/PartnerBanks/index.ts';
import RrsHandler from '../../../components/RrsHandler/index.ts';
import Section from '../../../components/Section/index.ts';
import SectionTitle from '../../../components/SectionTitle/index.ts';
import data from '../data.json';
import { RRS_REFIN } from '../RRS.ts';

import HeaderSection from './HeaderSection/HeaderSection.tsx';
import RefinancingArticle from './RefinancingArticle/RefinancingArticle.tsx';

// This component has to be extracted because it's used in both static and dynamic route segments
// React router cannot handle prerendering with loaders on parent even when parent layout is static
export function RefinancingPage(props: { testimonials: TestimonialsData }) {
  return (
    <>
      <SEO
        title="Refinansiering | Samle forbrukslån og kredittkort"
        description="Samle dyre smålån og kredittkortgjeld i ett lån med lavere rente. Søk fra 20 000 til 600 000 kr hos 13 banker."
        path={routes.PRODUCTS_REFINANCING}
      />
      <RrsHandler {...RRS_REFIN} />
      <HeaderSection variant="a1" />
      <Section background="paper">
        <Testimonials data={props.testimonials} />
      </Section>
      <Section background="paper">
        <SectionTitle title={data?.banksTitle || ''} />
        <PartnerBanks variant="unicolored" data={data?.banksLinksToggle} isRefin />
      </Section>
      <RefinancingArticle />
      <Section>
        <FaqList category="Refinansiering" />
      </Section>
      <Section extraPadding background="paper">
        <Circle position="topLeft" color="default" />
        <Circle position="bottomRight" color="default" />
        <SectionTitle title={data?.profitTitle || ''} subtitle={data?.profitDesc || ''} />
        <ActionButton
          label={data.profitButton}
          flow="debt_check"
          step="skip_start_from_refinansiering"
          color="secondary"
        />
      </Section>
    </>
  );
}
